import React from 'react';
import moment from 'moment';
import { History } from "history";
import { MasterPage } from "..";
// import NumberFormat from "react-number-format";
import { Alerta, Box, TipoAlerta, Botao, Row, Col, CampoEstatico, TipoCampoEstatico, CampoTexto, Combo, Form, } from '@intechprev/componentes-web';
import { NumFuncionalidade } from '../MasterPage';
import { SimuladorRendaMensalService } from '../../services/SimuladorRendaMensalService';
import { FuncionarioService, FichaFinanceiraService, PlanoService } from '../../services';
import { FuncionarioDados, PlanoVinculadoEntidade } from '../../entidades';
import { OpcoesTaxaContribuicao } from './OpcoesTaxaContribuicao';
import { OpcoesResgate } from './OpcoesResgate';
import { OpcoesRentabilidadeAnual } from './OpcoesRentabilidadeAnual';
import { Header } from './Header';

import { SimuladorRendaMensalResultado } from './SimuladorRendaMensalResultado';
import { reCAPTCHA } from '../../helpers';
import { LoadingComponent } from '../../components';
import NumberFormat from 'react-number-format';
import { handleFieldChange } from '@intechprev/react-lib';

export { SimuladorRendaMensalResultado }

interface Props {
  history?: History;
};

interface State {
  Ativo: boolean;
  Funcionario: FuncionarioDados;
  ValorSalario: number;
  SaldoAcomulado: number;
  FatorAtuarialInterpolado: number;
  Indice: number;
  DataInicioRMV: string;
  TaxaContribuicao: string;
  ContribuicaoMensal: number;
  ValorAporte: number;
  DataAporte: string;
  Resgate: string;
  RentabilidadeAnual: string;
  DataReferencia: string;

  Checked: boolean;
  CorCheckBox: string;
  AnoAtual: string;
  Loading: boolean;
  Erro: string;
};

export class SimuladorRendaMensal extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("simulador_renda_mensal");

  private page = React.createRef<MasterPage>();
  private formAporte = React.createRef<Form>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      Ativo: false,
      Funcionario: new FuncionarioDados(),
      ValorSalario: 0,
      SaldoAcomulado: 0,
      FatorAtuarialInterpolado: 0,
      Indice: 0,
      DataInicioRMV: "",
      ValorAporte: 0,
      DataAporte: "",
      Resgate: "",
      RentabilidadeAnual: "4",

      Checked: false,
      CorCheckBox: "danger",
      TaxaContribuicao: "",
      ContribuicaoMensal: 0,
      DataReferencia: "",
      AnoAtual: "",
      Loading: true,
      Erro: ""
    };
  }

  componentDidMount = async () => {
    try {
      const plano = await PlanoService.Buscar();
      const Ativo = this.CondicaoAtivo(plano);

      const UltimaContribuicao = await FichaFinanceiraService.BuscarUltimaExibicaoPorPlano("0002");
      const FatorAtuarialInterpolado = await SimuladorRendaMensalService.BuscarFatorAtuarialInterpolado();
      const Indice = await SimuladorRendaMensalService.BuscarIndice();
      const TaxaContribuicao = UltimaContribuicao.salario.length > 0 ?
        UltimaContribuicao.salario[0].SEQ_CONTRIBUICAO : 0;

      const ValorSalario = UltimaContribuicao.salario.length > 0 ?
        UltimaContribuicao.salario[0].SRC : 0;

      const ContribuicaoMensal = ValorSalario * TaxaContribuicao / 100;

      const SaldoAcomulado =
        ((UltimaContribuicao.saldosSem[0].QTD_COTA_RP_EMPRESA || 0) +
          (UltimaContribuicao.saldosSem[0].QTD_COTA_RP_PARTICIPANTE || 0) +
          (UltimaContribuicao.saldosCom[0].QTD_COTA_RP_EMPRESA || 0) +
          (UltimaContribuicao.saldosCom[0].QTD_COTA_RP_PARTICIPANTE || 0)
        ) * UltimaContribuicao.cotas[0].VALOR_IND;

      const DataReferencia = UltimaContribuicao.cotas[0].DT_IND;

      if (Ativo) {
        const Funcionario = await FuncionarioService.Buscar();
        this.setState({
          Ativo,
          Funcionario,
          ValorSalario,
          SaldoAcomulado,
          FatorAtuarialInterpolado,
          Indice,
          TaxaContribuicao,
          ContribuicaoMensal,
          DataReferencia,
          AnoAtual: moment().format("YYYY")
        });
      }

    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      this.setState({ Erro: Error });
    }
    finally {
      this.setState({ Loading: false });
    }
  }

  componentDidUpdate = () => {
    const titulo = document.getElementById("titulo");
    titulo.innerText = "Simulador de Renda Mensal Vitalícia";
  }

  CondicaoAtivo = (plano: Array<PlanoVinculadoEntidade>) => {
    return plano.some(p =>
      p.CD_PLANO === "0002" &&
      (p.CD_CATEGORIA === "1" ||
        p.CD_CATEGORIA === "3" ||
        p.CD_CATEGORIA === "6")
    );
  };

  SelecionarTaxa = (e: any) => {
    this.setState({
      ContribuicaoMensal: this.state.ValorSalario * parseInt(e.value, 10) / 100
    });
  }

  CondicaoAporteObrigatorio = () => {
    return (parseFloat(this.state.ValorAporte.toString()) > 0 || this.state.DataAporte.replace(/_|\//gm, "") !== "");
  }

  renderBoxBeneficioSimuladoAtual = () => {
    return (
      <Box titulo={"Benefício Simulado Atual"}>
        <h6 className={"text-center"}>{"Posição atual da sua Renda Mensal Vitalícia sem considerar o saque de até 25% à vista."}</h6>
        <h4 className={"text-center"}>
          {"Renda Mensal Vitalícia "}
          <span className={"text-success"}>
            <CampoEstatico
              valor={this.state.SaldoAcomulado / (13 * this.state.FatorAtuarialInterpolado)}
              tipo={TipoCampoEstatico.dinheiro}
            />
          </span>
        </h4>

        <hr />

        <h6 className={"text-center"}>{"Posição atual da sua Renda Mensal Vitalícia considerando o saque de 25% à vista."}</h6>
        <h4 className={"text-center"}>
          {"Valor do Saque "}
          <span className={"text-success"}>
            <CampoEstatico
              valor={this.state.SaldoAcomulado * 0.25}
              tipo={TipoCampoEstatico.dinheiro}
            />
          </span>

          {" - Renda Mensal Vitalícia "}
          <span className={"text-success"}>
            <CampoEstatico
              valor={(this.state.SaldoAcomulado / (13 * this.state.FatorAtuarialInterpolado)) * 0.75}
              tipo={TipoCampoEstatico.dinheiro}
            />
          </span>
        </h4>

        <Alerta
          tipo={TipoAlerta.info}
          mensagem={`Caso o valor inicial da renda inicial, apurada na data efetiva do primeiro pagamento do benefício, após o saque de 25%, seja igual ou inferior <b>R$ ${(this.state.Indice * 0.15).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>, correspondente a 15% (quinze por cento) do valor correspondente ao teto máximo de contribuição para a Previdência Social, será facultado o saque, à vista, da totalidade do saldo acumulado nas contas Participante e Patrocinador, em seu nome.`}
        />
      </Box>
    );
  }

  renderBoxDataInicioRMV = () => {
    return (
      <Box titulo={"Data de Início da RMV"} subtitulo={"Escolha a data de início do recebimento da sua RMV."}>
        <Alerta
          tipo={TipoAlerta.info}
          mensagem={"Você pode receber a Renda Mensal Vitalícia após a perda do vínculo empregatício com o seu Patrocinador, tendo cumprido 60 meses de permanência ininterrupta ao Plano, independente da idade. Não é exigida a aposentadoria pelo INSS para a concessão desse benefício (Art. 18 do Regulamento)."}
        />

        <CampoTexto
          contexto={this}
          nome={"DataInicioRMV"}
          obrigatorio
          mascara={"99/99/9999"}
          titulo={"Data Início RMV"}
          valor={this.state.DataInicioRMV}
        />
      </Box>
    );
  }

  renderBoxContribuicao = () => {
    return (
      <Box titulo={"Sua Contribuição"} subtitulo={"Você pode alterar o seu percentual de contribuição para as simulações!"}>
        <Combo
          contexto={this}
          titulo={"Taxa de Contribuição"}
          onChange={this.SelecionarTaxa}
          nome={"TaxaContribuicao"}
          valor={this.state.TaxaContribuicao}
          opcoes={OpcoesTaxaContribuicao}
          nomeMembro={"Nome"}
          valorMembro={"Valor"}
          padrao={this.state.TaxaContribuicao}
        />

        <CampoEstatico
          valor={this.state.ContribuicaoMensal}
          titulo={"Sua Contribuição Mensal"}
          tipo={TipoCampoEstatico.dinheiro}
        />

        <CampoEstatico
          valor={this.state.ContribuicaoMensal}
          titulo={"Contribuição Mensal Patronal"}
          tipo={TipoCampoEstatico.dinheiro}
        />
      </Box>
    );
  }

  renderBoxAporteFuturo = () => {
    return (
      <Box titulo={"Aporte Futuro"} subtitulo={"Para melhorar a sua aposentadoria, aqui você pode entrar com algum aporte para o plano, como uma contribuição extraordinária ou uma portabilidade de outro plano de benefícios. (não obrigatório)"}>
        <Form ref={this.formAporte}>
          {/* <CampoValor
            contexto={this}
            nome={"ValorAporte"}
            tipo={"dinheiro"}
            valor={this.state.ValorAporte}
            titulo={"Valor do Aporte (Em Reais)"}
            obrigatorio={this.CondicaoAporteObrigatorio()}
          /> */}

          <Row formGroup>
            <div className={"col-lg-2 col-md-12 text-lg-right col-form-label"}>
              <b>
                <label htmlFor={"ValorAporte"}>
                  {"Valor do Aporte (Em Reais)"}
                  {this.CondicaoAporteObrigatorio() && " *"}
                </label>
              </b>
            </div>

            <Col>
              <NumberFormat
                name={"ValorAporte"}
                id={"ValorAporte"}
                className={"form-control"}
                thousandSeparator={"."}
                decimalSeparator={","}
                decimalScale={2}
                allowedDecimalSeparators={[","]}
                fixedDecimalScale={true}
                value={this.state.ValorAporte}
                onChange={(e: any) =>
                  handleFieldChange(this, e, null)
                }
              />
            </Col>
          </Row>

          <CampoTexto
            contexto={this}
            nome={"DataAporte"}
            valor={this.state.DataAporte}
            titulo={"Data do Aporte"}
            mascara={"99/99/9999"}
            obrigatorio={this.CondicaoAporteObrigatorio()}
          />
        </Form>
      </Box>
    );
  }

  renderBoxResgate = () => {
    return (
      <Box titulo={"Resgate de Saldo à Vista"} subtitulo={"Você pode resgatar até 25% do seu saldo acumulado no início do seu recebimento da RMV."}>
        <Alerta
          tipo={TipoAlerta.info}
          mensagem={`No momento do requerimento do benefício, se, após o saque de 25%, o valor da renda calculada for menor ou igual a <b>R$ ${(this.state.Indice * 0.15).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> (valor em ${this.state.AnoAtual}), correspondente a 15% (quinze por cento) do teto máximo de contribuição para a Previdência Social, você poderá optar pelo Saque, à vista, da totalidade do saldo acumulado nas Contas Participante e Patrocinador, em seu nome, cancelando o Plano (Art. 18 do Regulamento).`}
        />

        <Combo
          contexto={this}
          titulo={"Resgate à Vista"}
          nome={"Resgate"}
          valor={this.state.Resgate}
          opcoes={OpcoesResgate}
          nomeMembro={"Nome"}
          valorMembro={"Valor"}
          padrao={"0"}
        />
      </Box>
    );
  }

  renderBoxRentabilidadeAnual = () => {
    return (
      <Box titulo={"Taxa de Rentabilidade Anual"} subtitulo={"Você pode projetar seu saldo e as contribuições futuras utilizando vários cenários de rentabilidade!"}>
        <Combo
          contexto={this}
          titulo={"Rentabilidade Anual"}
          nome={"RentabilidadeAnual"}
          valor={this.state.RentabilidadeAnual}
          opcoes={OpcoesRentabilidadeAnual}
          nomeMembro={"Nome"}
          valorMembro={"Valor"}
          padrao={"4"}
        />
      </Box>
    );
  }

  Simular = async (): Promise<any> => {
    try {
      await this.alerta.current.limparErros();
      await this.formAporte.current.validar();

      let DataAporte = "0";

      const DataInicioRMV = this.state.DataInicioRMV.replace(/\//gm, ".");

      if (this.state.DataInicioRMV === "") {
        await this.alerta.current.adicionarErro("Campo 'Data Início RMV' obrigatorio.");
        return null;
      }

      if (this.CondicaoAporteObrigatorio() && this.formAporte.current.isValido()) {
        if (parseFloat(this.state.ValorAporte.toString()) < 1) {
          await this.alerta.current.adicionarErro("Campo 'Valor do Aporte' deve ser maior que '0'.");
          return null;
        }

        DataAporte = this.state.DataAporte.replace(/\//gm, ".");

        await SimuladorRendaMensalService.ValidarDataAporte(DataAporte, DataInicioRMV);

      }
      else if (!this.formAporte.current.isValido()) {
        await this.alerta.current.adicionarErro(this.formAporte.current.erros[0]);
        return null;
      }

      await SimuladorRendaMensalService.ValidarDataInicioRMV(DataInicioRMV);

      const ValorAporte = (Number(this.state.ValorAporte.toString().split(",")[0].replace(/\./gm, ""))); // pq o campo valor usar number e nao string afinal

      this.props.history.push(`/simuladorRendaMensalResultado/${this.state.RentabilidadeAnual}/${this.state.TaxaContribuicao}/${this.state.Resgate}/${DataInicioRMV}/${DataAporte}/${ValorAporte}`);
    }
    catch (e) {
      const err: any = e;
      await this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  }

  renderAtivo = () => {
    if (this.state.Ativo) {
      return (
        <>
          <h4>{"Bem-Vindo ao Simulador de Renda Mensal Vitalícia (RMV)!"}</h4>

          <Box titulo={"Simulador RMV - Plano B"} subtitulo={`Olá, ${this.state.Funcionario.DadosPessoais.NOME_ENTID}! Os dados abaixo serão utilizados na simulação da sua RMV.`} label={`Posição de ${this.state.DataReferencia}`}>

            <Header
              DataNascimento={this.state.Funcionario.DadosPessoais.DT_NASCIMENTO}
              ValorSalario={this.state.ValorSalario}
              SaldoAcomulado={this.state.SaldoAcomulado}
            />

            {this.renderBoxBeneficioSimuladoAtual()}

            <Alerta
              tipo={TipoAlerta.success}
              mensagem={"<b>Cenário Futuro</b><br/>Simule abaixo um cenário futuro, alterando a sua contribuição e realizando aportes, em diferentes taxas de rentabilidade."}
            />

            {this.renderBoxDataInicioRMV()}

            {this.renderBoxContribuicao()}

            {this.renderBoxAporteFuturo()}

            {this.renderBoxResgate()}

            {this.renderBoxRentabilidadeAnual()}

            <div className={`d-flex align-items-baseline alert alert-${this.state.CorCheckBox}`}>
              <input
                type={"checkbox"}
                id={"manifestacao"}
                name={"manifestacao"}
                checked={this.state.Checked}
                onChange={() => {
                  this.setState({
                    Checked: !this.state.Checked,
                    CorCheckBox: !this.state.Checked ? "success" : "danger"
                  });
                }}
              />
              <label className={"m-2"} htmlFor={"manifestacao"}>
                {"Manifesto ciência que os valores de simulação tem caráter apenas ilustrativo, não gerando quaisquer direitos ao seu recebimento, e que o valor da renda dependerá do montante capitalizado resultante das contribuições efetivamente recolhidas e da rentabilidade real obtida durante o período de capitalização, bem como da característica etária do participante, na data da aposentadoria."}
              </label>
            </div>

            <Alerta
              ref={this.alerta}
              tipo={TipoAlerta.danger}
            />

            <Botao
              titulo={"Simular"}
              onClick={this.Simular}
              desativado={!this.state.Checked}
            />
          </Box>
        </>
      );
    }
    return (
      <Alerta
        tipo={TipoAlerta.info}
        mensagem={"Simulador de Renda Mensal Vitalícia disponível apenas para participantes ATIVOS do PLANO B."}
      />
    );
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_RENDA_MENSAL} {...this.props} ref={this.page}>
        {this.state.Loading && <LoadingComponent />}

        {!this.state.Loading && this.state.Erro && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.Erro} />}

        {!this.state.Loading && !this.state.Erro && this.renderAtivo()}
      </MasterPage>
    );
  }
}
